import { shallowMount } from "@vue/test-utils";
import CityList from "@/components/core/composite/combos/CityList";

describe("CityList component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(CityList);
  });

  it("Renders del component CityList", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
